/* GH-1133 S5 (§2.2 S7/S8, §2.8): "Copy text" for free-preview drafts.
   Caption editing is also available through the guarded GH-1249 editor.
   Inline "Copied" feedback on
   the button itself, not only a toast; clipboard API with an iOS Safari
   textarea fallback (lib/freePreview.copyText). */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '../Icons.jsx';
import { copyText } from '../../lib/freePreview.js';
import { trackPreview } from '../../lib/freePreviewEvents.js';

export default function CopyTextButton({ text, index = null, className = 'btn btn-secondary btn-sm' }) {
  const { t } = useTranslation();
  const [state, setState] = useState('idle');
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const onClick = async () => {
    const ok = await copyText(text || '');
    setState(ok ? 'copied' : 'failed');
    if (ok) trackPreview('preview_draft_copied', { index });
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setState('idle'), 2500);
  };
  return (
    <>
      <button type="button" className={`${className} fp-copy`} onClick={onClick} aria-live="polite">
        <Icon name={state === 'copied' ? 'check' : 'copy'} size={13} /> {state === 'copied' ? t('freePreview.copied') : t('freePreview.copyText')}
      </button>
      {state === 'failed' && <span className="fp-copy-failed" role="status">{t('freePreview.copyFailed')}</span>}
    </>
  );
}
